import { render, staticRenderFns } from "./WidgetImageMap.vue?vue&type=template&id=b4a04be8"
import script from "./WidgetImageMap.vue?vue&type=script&lang=js"
export * from "./WidgetImageMap.vue?vue&type=script&lang=js"
import style0 from "./WidgetImageMap.vue?vue&type=style&index=0&id=b4a04be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports